import React from 'react';
import {Col, Row} from "react-bootstrap";
import StandardField from "../../Fields/StandardField";
import * as yup from 'yup';
import {List} from "../../../../pages/RecordLocator";
import {getOptionsForField, yupDateRegex} from "../../../../utils/formHelpers";
import {BaseFormValues} from "./SCEventForm";

export const CONTACT_LOG_STRING = 'Contact Log';
export type CONTACT_LOG = typeof CONTACT_LOG_STRING;

export type ContactLogValues = BaseFormValues & {
    ConLogContactMadeBy: string;
    ConLogContactMadeTo: string;
    ConLogContactNotes: string;
    ConLogDateOfContact: string;
    ConLogFromTo: string;
    ConLogMethodOfContact: string;
    ConLogReasonForContact: string;
};

export const ContactLogSchema = {
    ConLogContactMadeBy: yup.string(),
    ConLogContactMadeTo: yup.string(),
    ConLogContactNotes: yup.string(),
    ConLogDateOfContact: yupDateRegex.required('You must enter a Contact Date'),
    ConLogFromTo: yup.string(),
    ConLogMethodOfContact: yup.string(),
    ConLogReasonForContact: yup.string()
};

type Props = {
    canSave : boolean;
    siteLists : Array<List>;
    handleSetFormIsModified : (formIsModified : boolean) => Promise<void>;
};

const ContactLogForm = ({
    canSave,
    siteLists,
    handleSetFormIsModified
} : Props) => {

    return (
        <>
            <Row className="mx-0 px-2">
                <Col xs={12} lg={4}>
                    <StandardField
                        name="ConLogDateOfContact"
                        type="date"
                        label="Contact Date"
                        disabled={!canSave}
                        handleSetFormIsModified={handleSetFormIsModified}
                    />
                </Col>
                <Col xs={12} lg={4}>
                    <StandardField
                        name="ConLogMethodOfContact"
                        type="select"
                        label="Contact Method"
                        disabled={!canSave}
                        handleSetFormIsModified={handleSetFormIsModified}
                        options={getOptionsForField(
                            'ContactMethod',
                            '',
                            siteLists
                        )}
                    />
                </Col>
            </Row>
            <Row className="mx-0 px-2">
                <Col xs={12} lg={4}>
                    <StandardField
                        name="ConLogContactMadeTo"
                        type="select"
                        label="Staff"
                        disabled={!canSave}
                        handleSetFormIsModified={handleSetFormIsModified}
                        options={getOptionsForField(
                            'UserList',
                            '',
                            siteLists
                        )}
                    />
                </Col>
                <Col xs={12} lg={4}>
                    <StandardField
                        name="ConLogFromTo"
                        type="radio"
                        label="Contact"
                        disabled={!canSave}
                        handleSetFormIsModified={handleSetFormIsModified}
                        options={getOptionsForField(
                            'FromTo',
                            '',
                            siteLists
                        )}
                    />
                </Col>
                <Col xs={12} lg={4}>
                    <StandardField
                        name="ConLogContactMadeBy"
                        type="text"
                        label="Made To"
                        disabled={!canSave}
                        handleSetFormIsModified={handleSetFormIsModified}
                    />
                </Col>
            </Row>
            <Row className="mx-0 px-2">
                <Col xs={12} lg={8}>
                    <StandardField
                        name="ConLogReasonForContact"
                        type="select"
                        label="Contact Reason"
                        disabled={!canSave}
                        handleSetFormIsModified={handleSetFormIsModified}
                        options={getOptionsForField(
                            'ContactLogReason',
                            '',
                            siteLists
                        )}
                    />
                </Col>
            </Row>
            <Row className="mx-0 px-2">
                <Col xs={12}>
                    <StandardField
                        name="ConLogContactNotes"
                        type="textarea"
                        label="Contact Notes"
                        disabled={!canSave}
                        className="textarea-lg"
                        handleSetFormIsModified={handleSetFormIsModified}
                    />
                </Col>
            </Row>
        </>
    );
};

export default ContactLogForm;